var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vinput" }, [
    _c("label", { staticClass: "vinput-label", attrs: { "for-id": _vm.id } }, [
      _vm._v(_vm._s(_vm.label))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vinput-wr" },
      [
        _vm.mask
          ? _c(
              "the-mask",
              _vm._b(
                {
                  ref: "input",
                  staticClass: "vinput-input",
                  attrs: {
                    id: _vm.id,
                    type: "text",
                    value: _vm.maskValue,
                    masked: true,
                    mask: _vm.mask
                  },
                  on: { input: _vm.handleInput },
                  nativeOn: {
                    focus: function($event) {
                      return _vm.handleFocus($event)
                    },
                    blur: function($event) {
                      return _vm.handleBlur($event)
                    }
                  }
                },
                "the-mask",
                _vm.$attrs,
                false
              )
            )
          : _c(
              "input",
              _vm._b(
                {
                  ref: "input",
                  staticClass: "vinput-input",
                  attrs: { id: _vm.id, type: _vm.type },
                  on: {
                    input: _vm.handleInput,
                    focus: _vm.handleFocus,
                    blur: _vm.handleBlur
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vinput_append-icon" },
          [_vm._t("append-icon")],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }